import { _ as __rest, a as __assign } from '../../tslib.es6-21effb23.js';
import { c as classNames } from '../../index-29eed6c4.js';
import React__default from 'react';

var styles = {"container":"TabPanel_container_6a0abc46","focus-visible":"TabPanel_focus-visible_6a0abc46"};

var TabPanel = function (_a) {
    var tabId = _a.tabId, selectedTabId = _a.selectedTabId, children = _a.children, className = _a.className, focusable = _a.focusable, otherProps = __rest(_a, ["tabId", "selectedTabId", "children", "className", "focusable"]);
    var isSelected = selectedTabId === tabId;
    return (React__default.createElement("div", __assign({ id: "tabpanel-".concat(tabId), "aria-labelledby": tabId, "aria-hidden": !isSelected, hidden: !isSelected, role: "tabpanel", tabIndex: focusable ? 0 : undefined, className: classNames(styles.container, className) }, otherProps), isSelected && children));
};

export { TabPanel };
